import HomePage from 'components/HomePage'

export const PAGE_MAP = {
  Main: `/`,
  Contact: `/contact`,
}

export const FRAGMENT_URL = '/homepage/_nexteufragment'

const ContactPage = () => 'Contact text'

const PAGE_TO_COMPONENT_MAP = {
  [PAGE_MAP.Main]: HomePage,
  [PAGE_MAP.Contact]: ContactPage,
}

export const RenderPage = (page: keyof typeof PAGE_MAP) => {
  const Component = PAGE_TO_COMPONENT_MAP[page]
  //@ts-ignore
  return Component ?? null
}
